//const BACKEND_URL = 'http://localhost:8080/Events/api/v1/';
import axios from 'axios';

export const WEB_URL = 'http://localhost:1234/#/';

export const EDIT_URL = WEB_URL + 'eventEdit/';

export const BACKEND_URL = 'http://localhost:8080/easyevent/api/v1/';

export const EVENT_IMG_URL = 'https://easyevent-ch-images.s3.eu-central-1.amazonaws.com/';

export const FACEBOOK_URL = 'http://www.facebook.com/share.php?u=';

export const TWITTER_URL = 'http://twitter.com/home/?status=';

export const WHATSAPP_URL = 'whatsapp://send?text=';

export const GOOGLEMAP_URL = 'https://www.google.com/maps/search/?api=1&query=';

export const TEMPORARY = 'TEMPORARY';

export const CREATED = 'CREATED';

export const BLOCKED = 'BLOCKED';

export const DEACTIVATED = 'DEACTIVATED';

export const ACTIVATED = 'ACTIVATED';


export function  getURL(path){
    return `${BACKEND_URL}${path}`;
}

export function sendJson(method, path, payload) {
  const url = `${BACKEND_URL}${path}`;

  return fetch(url, {
    method:  method,
    body:    JSON.stringify(payload),
    headers: {
      'Accept':       'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(response => response.json())
    .catch(ex => {
      console.error('parsing failed', ex);
    });
}

export function deleteItem( path, id) {
  const url = `${BACKEND_URL}${path}/${id}`;
  return fetch(url, { method: 'delete'})
    .then(response => response.json())
    .catch(ex => {
      console.error('parsing failed', ex);
    });
}


export function sendFile(file, path){
  const url = `${BACKEND_URL}${path}`;
  const formData = new FormData();
  formData.append('file',file);
  formData.append('name', 'test.pdf');
  
  return fetch(url, {
    method:  'post',
    body:    formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  }).then(response => console.log("file send "))
    .catch(ex => {
      console.error('parsing failed', ex);
    });

}

export function fetchJson(method, path, payload) {
  const url = `${BACKEND_URL}${path}`;

  return fetch(url, {
    method:  method,
    body:    JSON.stringify(payload),
    headers: {
      'Accept':       'application/json',
      'Content-Type': 'application/json'
    }
  })
    
}

export function  fileUpload(file, id, eventType) {
  if(!file){
    return;
  }
 
  let path = 'storage/uploadFile/' + id+'/'+eventType;
  const url = `${BACKEND_URL}${path}`;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('name', file.name);
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  }
   axios.post(url, formData, config);
   /* let oldState = this.state;
   this.setState({
     ...oldState,
     message: 'fileUploaded'
   });
   setTimeout(() => this.setState({ ...oldState, message: '' }), 1000);*/
}

export var isMobile = {
  Android: function() {
      return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
      return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },
  any: function() {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};
